import { render } from "./WCRadioButtonGroup.vue?vue&type=template&id=3471d146"
import script from "./WCRadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./WCRadioButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__